import { Skeleton } from "@/components/ui/skeleton";

export function MediaSummarySkeleton() {
  return (
    <div className="space-y-4">
      {/* Short paragraph */}
      <div className="space-y-2">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-5/6" />
      </div>

      {/* Bullet points */}
      <div className="space-y-3 pl-4">
        <div className="flex items-start gap-2">
          <Skeleton className="mt-1.5 h-2 w-2 shrink-0 rounded-full" />
          <Skeleton className="h-4 w-full" />
        </div>
        <div className="flex items-start gap-2">
          <Skeleton className="mt-1.5 h-2 w-2 shrink-0 rounded-full" />
          <Skeleton className="h-4 w-4/5" />
        </div>
        <div className="flex items-start gap-2">
          <Skeleton className="mt-1.5 h-2 w-2 shrink-0 rounded-full" />
          <Skeleton className="h-4 w-full" />
        </div>
        <div className="flex items-start gap-2">
          <Skeleton className="mt-1.5 h-2 w-2 shrink-0 rounded-full" />
          <Skeleton className="h-4 w-3/4" />
        </div>
      </div>

      {/* Short paragraph */}
      <div className="space-y-2">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-2/3" />
      </div>
    </div>
  );
}
